import { MIN_TRAINING_COMPLETION_SCORE } from "../data/securityModules";
export type ModuleExpiryState = "valid" | "soon" | "expired";

export type ModuleExpiry = {
  state: ModuleExpiryState;
  date: Date;
  daysLeft: number;
};

const SOON_WINDOW_DAYS = 30;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function getModuleExpiry(validUntil?: string | null): ModuleExpiry | null {
  if (!validUntil) return null;
  const date = new Date(validUntil);
  if (isNaN(date.getTime())) return null;
  const now = Date.now();
  const daysLeft = Math.ceil((date.getTime() - now) / MS_PER_DAY);
  const state: ModuleExpiryState =
    date.getTime() <= now ? "expired" : daysLeft <= SOON_WINDOW_DAYS ? "soon" : "valid";
  return { state, date, daysLeft };
}

/**
 * Zählt dieser Abschluss gerade als erledigt? Bestanden UND nicht abgelaufen.
 * Einheitliche Regel für Lernbereich, Wissenstest, Manager-Ansicht und
 * Admin-Zähler – dieselbe wie serverseitig userTrainingStatus() in
 * api/_modulePlan.js. Abgelaufene Abschlüsse dürfen weiter angezeigt werden
 * („abgelaufen am …"), zählen aber nirgends mehr als erledigt.
 */
export function isCurrentPass(record: { score: number; validUntil?: string | null }, now: number = Date.now()): boolean {
  if (!(record.score >= MIN_TRAINING_COMPLETION_SCORE)) return false;
  if (!record.validUntil) return true;
  const ms = Date.parse(record.validUntil);
  return Number.isNaN(ms) || ms > now;
}
